import React from 'react'
import { ReleaseAccordion } from '@/components/molecules/ReleaseAccordion/ReleaseAccordion'
import { ReleasePropTypes } from './types'

export const ReleaseSection: React.FC<ReleasePropTypes> = ({ release_notes }) => (
  <section className="font-sans">
    {release_notes.length && release_notes.map((release) => <ReleaseAccordion key={release._uid} {...release} />)}
  </section>
)

export default ReleaseSection
